import Connector from './connector';
import { PBADashboardIncomeStatement as Component } from './PBADashboardIncomeStatement';

export const PBADashboardIncomeStatement = () => <Connector component={Component} />;
